module.exports = __webpack_public_path__ + "img/201.9bdaf0f6.jpg";